export default {
	data(){
		return {
			updateFields: [
				'name',
				'subject',
				'body',
				'label',
				'show_at',
				'show_to',
				'qr_code_text',
				'qr_code_image',
				'qr_code_url',
				'image_url',
				'action_type',
				'action_id',
				'trigger_channel_ids',
				'device_group_settings',
				'confirm_per_device',
				'combine_recipient_conditions',
				'recipients',
				'send_to_device_group_type'
			],
			actionTypes: {
				"none": '-- '+this.$gettext('vyberte')+' --',
				"to_selfservice": this.$gettext('Přechod do samoobsluhy'),
				"to_message_detail": this.$gettext('Přechod do detailu oznámení'),
				"play_channel_live": this.$gettext('Spustit vybraný kanál'),
				"to_broadcast_detail": this.$gettext('Přechod do detailu vybraného pořadu'),
				"play_catchup_broadcast": this.$gettext('Přehrát vybraný pořad z CatchUpu'),
				"create_pvr": this.$gettext('Nahrát vybraný pořad')
			}
		}
	},

	methods: {
		getActionTypeText(type){
			return this.actionTypes[type];
		}
	},
	computed:{
		actionTypeOptions(){
			let options = [];
			Object.keys(this.actionTypes).forEach(key => {
				options.push({
					'id': key,
					'text': this.actionTypes[key]
				})
			});

			return options;
		}
	},

}



// WEBPACK FOOTER //
// ./src/components/views/advertisingBanner/mixins/advertisingBanners.js